import { hubspotContractsApis } from '@shared/apis';
import { genericMutation, genericQuery } from './generics';

export const useGetHubspotContractFilters =
  genericQuery<hubspotContractsApis.GetHubspotContractFilters>(
    hubspotContractsApis.getHubspotContractFilters
  );

export const useSyncHubspotContracts = genericMutation<hubspotContractsApis.SyncHubspotContracts>(
  hubspotContractsApis.syncHubspotContracts
);
